import { Col, Row } from 'antd';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { clearDealersModalFilter, setDealersModalFilter } from 'modules/dealers/actions';
import { getFilters } from 'modules/dealers/selectors/modalSelect';
import Button from 'ui/base/Button';
import Form from 'ui/base/Form';
import CountrySelect from 'ui/fields/selects/CountrySelect';

import GroupSelect from './GroupSelect';

/** @type {React.FC<{}>} */
const AdvancedSearch = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const filters = useSelector(getFilters);

  const handleOnCountryChange = values => {
    dispatch(setDealersModalFilter({ countryCodes: values }));
  };

  const handleClearFiltersOnClick = () => {
    dispatch(clearDealersModalFilter());
  };

  return (
    <div className="bg-secondary px-4 py-3">
      <Row type="flex" gutter={[16, 4]} justify="space-between" align="middle">
        <Col span={24} md={10}>
          <Form.Item label={<FormattedMessage id="page.config.dealer_general.country" defaultMessage="Country" />}>
            <CountrySelect
              mode="multiple"
              value={filters?.countryCodes}
              onChange={handleOnCountryChange}
              placeholder={intl.formatMessage({ id: 'countries', defaultMessage: 'Countries' })}
            />
          </Form.Item>
        </Col>
        <Col span={24} md={10}>
          <Form.Item label={<FormattedMessage id="group" defaultMessage="Group" />}>
            <GroupSelect />
          </Form.Item>
        </Col>
        <Col span={24} md={4}>
          <Button type="primary" ghost onClick={handleClearFiltersOnClick} block className="mt-3">
            <FormattedMessage id="page.home.filters.clear" defaultMessage="Clear filters" />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default AdvancedSearch;
